<template>
    <div>
        <p v-if="label != null" class="text-14 text-grey-900 pb-1">
            {{ $help.capitalizeFirstLetter(label) }}
        </p>

        <DropdownV2 :buttonCSS="['select-button !pr-0', error != false ? '!border-error' : '']" :preventButtonClick="true">
            <template #button="{ open, toggle }">
                <div class="flex items-center justify-between w-full">
                    <input
                        v-model="lValue"
                        :name="name"
                        :placeholder="placeholder"
                        :tabindex="tabIndex"
                        class="w-full h-full placeholder:text-grey-900 bg-transparent"
                        type="text"
                        @blur="$emit('change', lValue)"
                        @keyup="inputKeyup"
                        @click.prevent
                    />

                    <button class="h-12 w-12 flex items-center justify-center icon-hover" type="button" @click="toggle()">
                        <IconTime class="w-4.5 h-4.5 shrink-0" />
                    </button>
                </div>
            </template>

            <template #menu>
                <div
                    :style="{
                        'max-height': menuMaxHeight,
                    }"
                    class="select-menu"
                >
                    <button
                        v-for="(option, oi) in options"
                        :class="[
                            value == option.value ? selectedCSS : '',
                            {
                                'focus:bg-grey-500 hover:bg-grey-500': !dark,
                                'hover:bg-white/10 focus:bg-white/10': dark,
                            },
                        ]"
                        :disabled="option.disabled === true"
                        class="px-3 w-full h-10 text-left text-14 outline-0 transition-colors duration-300 disabled:text-grey-900 disabled:hover:bg-transparent"
                        data-close
                        type="button"
                        @click="
                            () => {
                                this.lValue = option.value
                                this.$emit('change', this.lValue)
                            }
                        "
                    >
                        {{ option.value }}
                    </button>
                </div>
            </template>
        </DropdownV2>

        <Error :error="error" :name="name" class="mr-[-100%]" />
    </div>
</template>

<script>
import DropdownV2 from '~/components/customer/input/dropdown-v2.vue'

export default {
    components: { DropdownV2 },
    props: {
        value: String,
        label: String,
        name: String,
        menuMaxHeight: { type: String, default: '240px' },
        placeholder: { type: String, default: '9:00' },
        tabIndex: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            lValue: this.value,
        }
    },

    mounted() {
        // console.log("TimePicker", this.value);
        if (this.value == null) {
            return
        }

        // let t = Math.ceil(this.value.split(":")[1] / 15);

        // if (t >= 4) {
        // 	t = 0;
        // }

        // this.lValue = `${
        // 	t == 0
        // 		? parseInt(this.value.split(":")[0]) + 1
        // 		: this.value.split(":")[0]
        // }:${t == 0 ? "00" : t * 15}`;

        // this.$emit("change", this.lValue);
    },

    methods: {
        inputKeyup(event) {
            let value = event.target.value
            let len = value.length
            let hh = parseInt(value.split(':')[0])
            let mm = parseInt(value.split(':')[1])
            let newValue = ''

            if (hh > 2 && event.code != 'Backspace') {
                newValue = hh + ':'
            } else {
                newValue = value
            }

            // console.log("newValue", [newValue, hh, mm]);

            if (String(mm).length == 2) {
                let fif = Math.ceil(mm / 15)
                // console.log(fif);

                if (fif > 3) {
                    newValue = parseInt(newValue.split(':')[0]) + 1 + ':00'
                } else {
                    newValue = newValue.split(':')[0] + ':' + fif * 15
                }
            } else if (String(mm).length == 1) {
                newValue = value
            }

            // console.log("newValue", [event, newValue, hh, mm]);

            this.lValue = newValue

            return this.lValue
        },
    },

    computed: {
        options() {
            let a = []

            for (let h = 0; h <= 23; h++) {
                for (let m = 0; m <= 45; m += 15) {
                    a.push({
                        value: `${h < 10 ? '0' + String(h) : h}:${m < 10 ? '0' + String(m) : m}`,
                    })
                }
            }

            return a
        },

        error() {
            return this.$help.getComponent(this, 'InputForm').$data.errors.has(this.name)
        },
    },
}
</script>
